export default __webpack_public_path__ + "static/media/Proveedores_Formato_de_complementos_de_pago.f06e902d.xlsx";